import { render } from "./ImpuestoList.vue?vue&type=template&id=03723e8a&scoped=true"
import script from "./ImpuestoList.vue?vue&type=script&lang=js"
export * from "./ImpuestoList.vue?vue&type=script&lang=js"

import "./ImpuestoList.vue?vue&type=style&index=0&id=03723e8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03723e8a"]])

export default __exports__